import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { useEffect } from 'react';
import { initializeNotificationScheduler } from './utils/notificationScheduler';

function NotificationInitializer() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // 通知スケジューラーを初期化
      initializeNotificationScheduler(user.id);
    }
  }, [user]);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <NotificationInitializer />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;